// @LTG-ID: F-013
// @STATUS: BUILT
// @HERMETIC: true  // no external state — fully static
// @DOCS: 08_FEATURES.md#F-013, source Landing Page.html lines 2212-2261
// @CHANGED: 2026-02 session_003 (CHG-0042)
// @OWNER: web
//
// F-013 — Methodology. Three cards (Inputs / Outputs / Boundary) plus the
// navy "honest" closing paragraph. Verbatim port. No sector dependency, no
// interactivity. The `tel:+17045993355` link is a genuine outbound non-CRM
// link and stays as a bare anchor (the no-bare-anchor rule applies only to
// `app.letstalkgrowth.com` per ADR-008).

import ItalicPeriod from "../brand/ItalicPeriod";
import "./methodology.css";

export function Methodology() {
    return (
        <section
            className="ltg-methodology-section"
            id="methodology"
            data-testid="methodology-section"
        >
            <div className="ltg-narrow">
                <div className="ltg-block-head">
                    <span
                        className="ltg-eyebrow"
                        data-testid="methodology-eyebrow"
                    >
                        How we work
                    </span>
                    <h2 data-testid="methodology-h2">
                        We name the inputs. We name the outputs. We name the
                        line we will not cross
                        <ItalicPeriod />
                    </h2>
                </div>

                <div className="ltg-method-grid" data-testid="methodology-grid">
                    <div
                        className="ltg-method-card"
                        data-testid="methodology-card-inputs"
                    >
                        <span className="ltg-method-card__num">01</span>
                        <h3>Inputs</h3>
                        <ul>
                            <li>
                                ~12 normalized P&amp;L line items, your last
                                36 months
                            </li>
                            <li>
                                The Strategic 50Q: 50 value-driver questions
                                across eight pillars
                            </li>
                            <li>
                                The Exit 20Q: 20 deal-killer questions tuned
                                to your sector
                            </li>
                            <li>
                                The Freedom 23Q: 23 questions on what comes
                                after the sale
                            </li>
                            <li>Your sector code and operating vocabulary</li>
                        </ul>
                    </div>
                    <div
                        className="ltg-method-card"
                        data-testid="methodology-card-outputs"
                    >
                        <span className="ltg-method-card__num">02</span>
                        <h3>Outputs</h3>
                        <ul>
                            <li>
                                Indicative enterprise value range: low, median,
                                top quartile
                            </li>
                            <li>
                                Strategic Score, Exit Score, Freedom Score
                                (each 0–100)
                            </li>
                            <li>
                                Ten levers, ranked by impact on your valuation
                            </li>
                            <li>
                                A 60-month projected value curve under three
                                scenarios
                            </li>
                            <li>
                                One round of written Q&amp;A with Sara, signed
                                and personal
                            </li>
                        </ul>
                    </div>
                    <div
                        className="ltg-method-card"
                        data-testid="methodology-card-boundary"
                    >
                        <span className="ltg-method-card__num">03</span>
                        <h3>The boundary</h3>
                        <ul>
                            <li>Indicative valuation only</li>
                            <li>
                                <strong>Not</strong> a USPAP-compliant business
                                appraisal under SSVS No. 1
                            </li>
                            <li>Not investment, legal, or tax advice</li>
                            <li>
                                For SBA loan, litigation, gift / estate, or
                                ESOP work, engage a credentialed appraiser
                                (ASA, ABV, CVA, CBA)
                            </li>
                            <li>
                                KGOB does formal appraisals separately. Call{" "}
                                <a href="tel:+17045993355">(704) 599-3355</a>.
                            </li>
                        </ul>
                    </div>
                </div>

                <p
                    className="ltg-method-honest"
                    data-testid="methodology-honest"
                >
                    We tell you the inputs we use, the outputs you get, and the
                    line we will not cross. We do not show you the formula,
                    because the formula is 38 years of CPA-firm pattern
                    recognition, encoded into a model. The output is honest.
                    The model is ours.
                </p>
            </div>
        </section>
    );
}

export default Methodology;
